// extracted by mini-css-extract-plugin
export default {"pass_reset_container":"PassReset_pass_reset_container__3q8dR","pass_reset_title":"PassReset_pass_reset_title__QyEku"};